import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { FaArrowLeft } from "react-icons/fa";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  useCreateCustomerOtpMutation,
  useCustomerLoginMutation,
  useCustomerTableLoginMutation,
} from "../slices/customerSlice";
import {
  useCreateOrderMutation,
  useCreateTableOrderMutation,
} from "../slices/OrdersSlice";
import { useDispatch, useSelector } from "react-redux";
import { setCredentials } from "../slices/authSlice";
import { useCheckFoodItemAvailabilityMutation } from "../slices/FoodItemSilce";
import ReUsableModal from "../components/ReUsableModal";
import { setFoodList } from "../slices/foodListSlice";

const FoodAppLoginScreen = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const [mobileNumber, setMobileNumber] = useState("9876987698");
  const [getOtp, setGetOtp] = useState("1234");
  const [otpSent, setOtpSent] = useState(userInfo?.token ? true : false);
  const [otpVerified, setOtpVerified] = useState(
    userInfo?.token ? true : false
  );
  const dispatch = useDispatch();

  const { state } = useLocation();

  const { redirectTo } = state || {};
  // const {
  //   selectedItems = [],
  //   companyName = "",
  //   outletAddress = "",
  // } = location.state || {};
  const navigate = useNavigate();

  const [generateOtp] = useCreateCustomerOtpMutation();
  const [verifyOtp, { isLoading: verifyOtpLoading }] =
    useCustomerLoginMutation();
  const [tableLogin, { isLoading: tableLoginLoading }] =
    useCustomerTableLoginMutation();

  const handleGetOtp = async () => {
    //console.log(mobileNumber);
    if (mobileNumber?.length === 10) {
      //console.log("OTP sent");
      const resData = await generateOtp({ mobileNumber });
      toast.success("please enter OTP sent to your mobile number");
      setOtpSent(true);
      // alert("OTP sent to " + resData);
    } else {
      // console.log("Please enter valid mobileNumber");
      toast.error("Please enter valid mobileNumber");
    }
  };

  const verifyOtpHandler = async () => {
    try {
      let resData = null;
      if (userInfo?.tableDetails) {
        resData = await tableLogin({
          mobileNumber: Number(mobileNumber),
          recentOTP: Number(getOtp),
          outletId: userInfo?.outletsDetails[0]?._id,
          floor: userInfo?.tableDetails.floor,
          tableNumber: userInfo?.tableDetails.tableNumber,
        }).unwrap();
      } else {
        resData = await verifyOtp({
          mobileNum: Number(mobileNumber),
          recentOTP: Number(getOtp),
        }).unwrap();
      }

      if (resData?.token) {
        setOtpVerified(true);
        dispatch(
          setCredentials({
            ...userInfo,
            token: resData?.token,
            tableOrderDetails: resData,
            favouriteOutlets: resData?.favouriteOutlets,
            favouriteFoods: resData?.favouriteFoods,
          })
        );
        // ⬇️ Redirect to intended page after login
        console.log("redirectTo");
        console.log(redirectTo);
        if (redirectTo) {
          navigate(redirectTo);
        }
      }
    } catch (e) {
      console.log("Error in verify otp", e);
      toast.error("OTP is not correct");
    }
  };

  return (
    <div>
      <Row className="justify-content-center text-center">
        <Col md={6}>
          <h4 style={{ color: "black" }}>
            {userInfo?.outletsDetails &&
              userInfo?.outletsDetails[0]?.companyId?.companyName}
          </h4>
          <p className="login-subtitle">
            {userInfo?.outletsDetails &&
              userInfo?.outletsDetails[0]?.companyId?.companyCity}
          </p>
          {userInfo?.outletsDetails[0]?.companyId?.companyCategory?.toLowerCase() ===
            "theatre" &&
            !userInfo?.deliveryTo?.toLowerCase().includes("undefined") && (
              <h6 className="login-label">Seat - {userInfo?.deliveryTo}</h6>
            )}
          {!userInfo?.token && (
            <>
              {!otpVerified && (
                <h5 className="login-label">Login with mobile number</h5>
              )}
              <Form.Control
                type="text"
                style={{ height: "3.5rem", fontSize: "1.3rem" }}
                placeholder="Enter mobile number"
                value={mobileNumber}
                onChange={(e) => {
                  const onlyNums = e.target.value.replace(/\D/g, "");
                  setMobileNumber(onlyNums);
                }}
                disabled={otpSent}
              />
              <br />
              {!otpSent ? (
                <Button style={{ height: "2.5rem" }} onClick={handleGetOtp}>
                  Get OTP
                </Button>
              ) : (
                !otpVerified && (
                  <>
                    <Form.Control
                      style={{ height: "3.5rem", fontSize: "1.3rem" }}
                      type="text"
                      className="form-control mb-3 w-100 mx-auto"
                      placeholder="Enter OTP"
                      value={getOtp}
                      onChange={(e) => {
                        const onlyNums = e.target.value.replace(/\D/g, "");
                        setGetOtp(onlyNums);
                      }}
                    />
                    <br />
                    <Button
                      style={{ height: "2.5rem" }}
                      onClick={verifyOtpHandler}
                    >
                      Login
                    </Button>
                  </>
                )
              )}
            </>
          )}{" "}
        </Col>
      </Row>
    </div>
  );
};

export default FoodAppLoginScreen;
